export enum NotificationType {
  TICKET_CREATED = 'ticket_created',
  ASSIGNED = 'assigned',
  STATUS_CHANGED = 'status_changed',
  COMMENT_ADDED = 'comment_added',
  RESOLVED = 'resolved'
}
